import { create } from 'zustand'
import { immer } from 'zustand/middleware/immer'

import { getIsGO } from '../../../1stlog-ui/src/utils/getIsGO'
import { InlineTrackingData, InlineTrackingStore } from './types'

export const useInlineTrackingStore = create(
  immer<InlineTrackingStore>((set) => ({
    isOpen: false,
    open: (data: InlineTrackingData) => {
      set((state) => {
        state.isOpen = true
        state.data = data
      })
    },
    close: () => {
      set((state) => {
        state.isOpen = false
        state.data = null
      })
    },
    data: null,
    isActive: getIsGO(),
  })),
)
